module.exports = __webpack_public_path__ + "img/resource-tech-image-31.ffa10b54.jpg";